import { GridColDef } from "@mui/x-data-grid-pro";
import {
  Box,
  GKClientDataGrid,
  Grid2,
  NoData,
  RightIcon,
  Show,
  StatusField,
  Typography,
} from "components";
import { useFetchQuery } from "hooks/useQueries";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { SET_EQUITY_BASKET_LIST } from "store/slices/equityBasketSlice";
import { extraColumnsField, matchDate } from "utils/helpers";

const ViewTelegramTab = () => {
  const { id } = useParams<{ id: string }>();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { data } = useFetchQuery({
    key: ["TELEGRAM_CHANNELS", id],
    route: `/telegram-channels/?basket=${id}`,
  });

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Channel Name", "channelName", 120, 1),
    },
    {
      ...extraColumnsField("Channel Id", "channelId", 120, 1),
    },
    {
      ...extraColumnsField("Status", "isActive", 120, 1),
      renderCell: (params) => (
        <StatusField
          statusString={params.row.isActive ? "approved" : "pending"}
        />
      ),
    },
    {
      ...extraColumnsField("Created", "createdAt", 120, 1),
      renderCell: (value) => (
        <Typography>{matchDate(value.row.createdAt) || "N/A"}</Typography>
      ),
    },
  ];

  return (
    <>
      <Grid2 container spacing={1}>
        <Show.When isTrue={data?.data?.data?.length === 0}>
          <Grid2 size={12}>
            <NoData
              customImg={
                <img
                  loading="lazy"
                  alt=""
                  src="/LandingPage/telegram.svg"
                  draggable={"false"}
                />
              }
              text="No Telegram channel or group connected"
              subText="This basket has no linked Telegram channel or group yet."
              additionalComponent={
                <Box
                  display="flex"
                  alignItems="center"
                  pl={3}
                  gap={0.5}
                  sx={{
                    cursor: "pointer",
                    color: "var(--primary-main)",
                    "&:hover": { textDecoration: "underline" },
                  }}
                  onClick={() => {
                    navigate(`/app/equity-basket/${id}/edit`);
                    dispatch(SET_EQUITY_BASKET_LIST(5));
                  }}
                >
                  <Typography
                    fontSize={13}
                    fontWeight={500}
                    color="var(--primary-900)"
                  >
                    Navigate to Add New Channel or Group Details
                  </Typography>
                  <RightIcon color="var(--primary-900)" />
                </Box>
              }
            />
          </Grid2>
        </Show.When>

        <Show.When isTrue={data?.data?.data?.length > 0}>
          <Grid2 size={8}>
            <GKClientDataGrid
              columns={columns}
              rows={data?.data?.data || []}
              name="telegramTab"
            />
          </Grid2>
        </Show.When>
      </Grid2>
    </>
  );
};

export default ViewTelegramTab;
